import { z } from 'zod';
const timestamp = z.string().datetime({ offset: true });
const cursorSchema = z.object({ before: timestamp, beforeId: z.string().uuid() }).strict();
export const allocationTrainingPreviewQuerySchema = z.object({
    requestedRoute: z.enum(['refresher', 'du']).optional(),
    historyLimit: z.coerce.number().int().min(1).max(100).default(50),
    before: timestamp.optional(),
    beforeId: z.string().uuid().optional(),
}).strict().refine(value => (value.before === undefined) === (value.beforeId === undefined), {
    message: 'before and beforeId must be supplied together',
});
export const allocationTrainingStateSchema = z.object({
    section: z.string().nullable(),
    category: z.string().nullable(),
    matching_status: z.string().nullable(),
    employee_status: z.string().nullable(),
    availability_status: z.string().nullable(),
    for_match_flag: z.string().nullable(),
    last_cohort_training: z.string().nullable(),
    new_product_training: z.string().nullable(),
    training_remarks: z.string().nullable(),
    retraining_date_1st: z.string().nullable(),
    retraining_date_2nd: z.string().nullable(),
    learnworlds_id: z.string().nullable(),
}).strict();
export const allocationTrainingScoreSchema = z.object({
    id: z.string().uuid(),
    doer_id: z.string().uuid(),
    score: z.number(),
    max_score: z.number().nullable(),
    score_type: z.string().nullable(),
    cohort_type: z.string().nullable(),
    matching_status_snapshot: z.string().nullable(),
    created_at: timestamp,
    updated_at: timestamp,
}).strict();
export const allocationTrainingPreviewResponseSchema = z.object({
    doer: z.object({ id: z.string().uuid(), doer_code: z.string().nullable(), name: z.string() }).strict(),
    generatedAt: timestamp,
    sourceScope: z.literal('allocation_persisted_only'),
    current: allocationTrainingStateSchema,
    completion: z.literal('unknown'),
    routeReview: z.object({
        requestedRoute: z.enum(['refresher', 'du']).nullable(),
        status: z.literal('requires_review'),
        requirements: z.array(z.object({
            code: z.enum(['route_policy', 'individual_exam_results', 'behavior_and_hr_decision', 'enrollment_contract']),
            detail: z.string(),
        }).strict()),
    }).strict(),
    scores: z.object({
        state: z.enum(['no_linked_observations', 'observations_present']),
        linkage: z.literal('exact_doer_id'),
        hasMore: z.boolean(),
        observations: z.array(allocationTrainingScoreSchema),
    }).strict(),
    history: z.object({
        scannedRows: z.number().int().nonnegative(),
        hasMore: z.boolean(),
        nextCursor: cursorSchema.nullable(),
        events: z.array(z.object({
            auditIds: z.array(z.string().uuid()).min(1),
            observedAt: timestamp,
            action: z.string(),
            actor: z.object({ id: z.string().uuid().nullable(), attribution: z.enum(['recorded_user', 'unattributed']) }).strict(),
            changedFields: z.array(allocationTrainingStateSchema.keyof()),
            before: allocationTrainingStateSchema,
            after: allocationTrainingStateSchema,
        }).strict()),
    }).strict(),
    limitations: z.array(z.string()),
}).strict();
//# sourceMappingURL=allocation-training-preview.js.map